$(function() {

    // イベント　いいね
    $('.js-event-goodTrigger').click(function () {
        onEventGood($(this).data('event-id'));
    });

    // ブログ　お気に入り
    $('.js-event-favoriteTrigger').click(function () {
        onEventFavorite($(this).data('event-id'));
    });

    // コメント入力
    $('.js-event-commentOpen').click(function () {
        const eventId = $(this).data('event-id');
        $(`.js-event-commentForm[data-event-id=${eventId}]`).show();
    });

    // コメントキャンセル
    $('.js-event-commentCancel').click(function () {
        const eventId = $(this).data('event-id');
        $(`.js-event-commentForm[data-event-id=${eventId}] [name=comment]`).val('');
        $(`.js-event-commentForm[data-event-id=${eventId}]`).hide();
    });

    // コメント返信入力
    $('.js-event-replyOpen').click(function () {
        const replyId = $(this).data('reply-id');
        $(`.js-event-replyForm[data-reply-id=${replyId}]`).show();
    });

    // コメント返信キャンセル
    $('.js-event-replyCancel').click(function () {
        const replyId = $(this).data('reply-id');
        $(`.js-event-replyForm[data-reply-id=${replyId}] [name=comment]`).val('');
        $(`.js-event-replyForm[data-reply-id=${replyId}]`).hide();
    });

    // コメントもっと見る
    $('.js-event-showMoreComments').click(function () {
        if ($('.js-event-moreComments').is(':visible')) {
            $(this).text('もっと見る ▼');
        } else {
            $(this).text('閉じる ▲');
        }
        $('.js-event-moreComments').slideToggle();
    });

    // コメント送信のバリデーション
    $('.js-event-commentForm button[type="submit"]').click(function (e) {
        var $form = $(this).parents('.js-event-commentForm');

        if (!$('[name="comment"]', $form).val()) {
            $('.box-textarea', $form).addClass('is-error');
            $('.box-textarea .is-error-txt', $form).show();
            e.preventDefault();
        }
    });

    // コメント返信のバリデーション
    $('.js-event-replyForm button[type="submit"]').click(function (e) {
        var $form = $(this).parents('.js-event-replyForm');

        if (!$('[name="comment"]', $form).val()) {
            $('.box-textarea', $form).addClass('is-error');
            $('.box-textarea .is-error-txt', $form).show();
            e.preventDefault();
        }
    });

    // 了承するの確認ボタンの無効制御
    $('#eve-agree').change(function() {
        let result = $(this).prop('checked');
        let btnObj = $('#entry-confirm-btn');
        if(result) 
          btnObj.prop('disabled', false);
        else 
          btnObj.prop('disabled', true);
    });
    // 有料イベント申し込み時のボタン・チェックボックス無効制御
    $('#area-event-detail .btn-eve-submit').on('click',function() {
        $(this).prop('disabled',true);
        let formObj = $(this).parents('form');
        let inputObj = formObj.find('input[type="checkbox"]');
        inputObj.prop('disabled',true);
        formObj.append('<input type="hidden" name="accept" value="1">');
        formObj.submit();
    });

    // イベント参加履歴の有料/無料切り替え
    $('#area-pShopping .toggle-like').on('change',function() {
        location.href = "/my/purchase/event"+($(this).prop('checked') ? "?charge=1" : "");
    });

    $('.js-event-confirmModal--trigger').on('click', function () {
        console.log($('js-event-confirmModal'));
        $('.js-event-confirmModal').show();
    });
});

// イベント　いいね
window.onEventGood = function(eventId) {
    var $triggerEle = $(`.js-event-goodTrigger[data-event-id=${eventId}]`);
    var $countEle = $(`.js-event-goodCount[data-event-id=${eventId}]`);
    const apiUrl = $triggerEle.data('api-url');

    $.post(apiUrl).done(function (response) {
        if (response.status) {
            if (response.good) {
                $triggerEle.addClass('icn-like-on').removeClass('icn-like-off');
                $countEle.text(parseInt($countEle.text()) + 1);
            } else {
                $triggerEle.removeClass('icn-like-on').addClass('icn-like-off');
                $countEle.text(parseInt($countEle.text()) - 1);
            }
        } else {
            alert(response.message);
        }
    }).fail(function () {
        alert('いいねできませんでした。');
    });
}

// ブログ　お気に入り
window.onEventFavorite = async function(eventId) {
    var $triggerEle = $(`.js-event-favoriteTrigger[data-event-id=${eventId}]`);
    var $countEle = $(`.js-event-favoriteCount[data-event-id=${eventId}]`);
    var $listCountEle = $('#listFavoriteCount');
    const apiUrl = $triggerEle.data('api-url');

    try {
        const response = await $.post(apiUrl);
        if (response.status) {
            if (response.favorite) {
                $triggerEle.addClass('icn-heart-on').removeClass('icn-heart-off');
                $countEle.text(parseInt($countEle.text()) + 1);
                if ($listCountEle) {
                    $listCountEle.text(parseInt($listCountEle.text()) + 1);
                }
            } else {
                $triggerEle.removeClass('icn-heart-on').addClass('icn-heart-off');
                $countEle.text(parseInt($countEle.text()) - 1);
                if ($listCountEle) {
                    $listCountEle.text(parseInt($listCountEle.text()) - 1);
                }
            }
        } else {
            alert(response.message);
        }
    } catch (error) {
        alert('お気に入りできませんでした。');
    }
}
